// stores/main.js
import { defineStore } from "pinia";
import api from "@/services/api";
import { get, set } from "idb-keyval";
import tokenService from "@/services/token.service";
import settingService from "@/services/setting.service";
import configurationService from "@shared/services/configuration.service";
import { useLocalStorage } from "@vueuse/core";

export const useDataStore = defineStore({
  id: "data",
  state: () => ({
    location: [],
    data: [],
    settings: [],
    configs: useLocalStorage("configs", []),
    roles: [],
    permissions: [],
  }),
  getters: {
    getConfigValue: (state) => (key) => {
      const findValue = (obj, key) => {
        for (const k in obj) {
          if (typeof obj[k] === "object" && obj[k] !== null) {
            if (obj[k].key === key) {
              return obj[k].value;
            }
            const value = findValue(obj[k], key);
            if (value !== undefined) {
              return value;
            }
          }
        }
        return undefined;
      };

      return findValue(state.configs, key);
    },

    getAllConfigs(state) {
      return state.configs;
    },
    getLocation() {
      return this.location;
    },
    getData() {
      return this.data;
    },
    getCountry() {
      return this.location.country;
    },
    getRoles() {
      return this.roles;
    },
    getPermissions() {
      return this.permissions;
    },
    getSetting:
      (state) =>
      (key = null) => {
        let data = state.settings;

        if (key === null) {
          return data;
        }

        console.log(typeof key, typeof key == "object");
        if (typeof key === "string") {
          let keys = key.split(".");
          let temp = data;

          for (let k of keys) {
            if (temp && Object.prototype.hasOwnProperty.call(temp, k)) {
              temp = temp[k];
            } else {
              return false;
            }
          }

          return temp;
        }
        return false;
      },
    getCountryById:
      (state) =>
      (country_code = null) => {
        let data = state.location.country || {};
        return data[country_code];
      },
    getCityById:
      (state) =>
      (id = null) => {
        let data = state.location.city;
        let x = data[id];
        return x;
      },
    getDistrictById:
      (state) =>
      (id = null) => {
        let data = state.location.district;
        return data[id];
      },
    getWardsById:
      (state) =>
      (id = null) => {
        let data = state.location.wards;
        return data[id];
      },
    getCity:
      (state) =>
      (country_code = null) => {
        let data = state.location.city;

        if (country_code !== null && data != undefined) {
          data = Object.fromEntries(
            Object.entries(data).filter(
              ([, value]) => value.country === country_code
            )
          );
        }

        return data;
      },
    getDistrict:
      (state) =>
      (parent_code = null) => {
        let data = state.location.district;
        if (parent_code !== null) {
          data = Object.fromEntries(
            Object.entries(data).filter(
              ([, value]) => value.parent_code === parent_code
            )
          );
        }
        return data;
      },
    getWards:
      (state) =>
      (parent_code = null, id = null) => {
        let data = state.location.wards;
        if (parent_code !== null) {
          data = Object.fromEntries(
            Object.entries(data).filter(
              ([, value]) => value.parent_code === parent_code
            )
          );
        }
        if (id != null) {
          return Object.entries(data).filter(([, value]) => value.id === id);
        }
        return data;
      },
  },
  actions: {
    async fetchConfigs(isConfigData=0) {
      var configs = await get("getAllConfigs");
      if (isConfigData || !configs) {
        try {
          const defaultResponse =
            await configurationService.getDefaultConfigurations();
          if (defaultResponse.data.success) {
            this.configsDefault = defaultResponse.data.data;
          }
  
          const dataResponse = await configurationService.getDataConfigurations();
          if (dataResponse.data.success && dataResponse.data.content) {
            this.configsData = dataResponse.data.content;
          }
  
          if (this.configsData) {
            const mergedConfigs = { ...this.configsData };
            if (this.configsDefault) {
              Object.keys(this.configsDefault).forEach((key) => {
                const item = this.configsDefault[key];
                mergedConfigs[item.key] = item;
              });
            }
            this.configs = mergedConfigs;
          }
        } catch (error) {
          console.error("Failed to fetch configurations:", error);
        }
      }else{
        this.configs = await get("getAllConfigs");
      }
    },

    hasCity(country_code) {
      const cities = this.getCity(country_code);
      if (cities && typeof cities === "object") {
        return Object.keys(cities).length;
      } else {
        return 0;
      }
    },
    getFullAddress(info) {
      if(info==null)
          return
      let address = info.address ? info.address : "";

      if (info.country) {
        if (this.hasCity(info.country)) {
          let data;
          if (info.city) {
            data = this.getCityById(info.city);
          }
          if (info.district) {
            data = this.getDistrictById(info.district);
          }
          if (info.wards) {
            data = this.getWardsById(info.wards);
          }

          try {
            address +=
              " " + (data?.path_with_type || data?.name_with_type || "");
          } catch (e) {
            console.error(e);
          }
        }
      }

      const country = this.getCountryById(info.country);
      address += country ? `, ${country}` : "";

      return address;
    },
    async setSetting(params) {
      try {
        const user = tokenService.getUser();
        if (user != null) {
          let ver = this.settings.ver || null;
          const result = await settingService.getSettings({
            ver: ver,
            ...params,
          });

          this.settings = result.data.data.setting;
          if (result.data.data.roles != undefined) {
            this.roles = result.data.data.roles;
          }
          if (result.data.data.permissions != undefined) {
            this.permissions = result.data.data.permissions;
          }

          if (result.data.data.user_pem != undefined) {
            tokenService.setPem(result.data.data.user_pem);
            this.$patch({
              "auth/pem": "",
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async initializeData() {
     
      if (localStorage.getItem("updated")==0) {
        localStorage.setItem("updated",1)
       
        await api
          .get("setting/intialize")
          .then((response) => {
           
            let version = response.data.version;
            localStorage.setItem("version", version);
            this.location = response.data.data.location;
            let options = {};
            localStorage.setItem("updated",1);
            let data = response.data.data;
            data.options.forEach((item) => {
              if (!options[item.type]) {
                options[item.type] = {};
              }
              options[item.type][item.id] = item;
            });
            delete data.options;
            data.options = options;
          
            set("setLocation", response.data.data.location);
            delete response.data.data.location;
            this.data = response.data.data;
            set("setData", response.data.data);
          })
          .catch(function (error) {
            console.log("error_catch", error);
          });
        get;
      } else {
        this.location = await get("setLocation");
        this.data = await get("setData");
      }
    },
    async fectDataOption() {
      
      const user = tokenService.getUser();
      if (user == null) {
        return;
      }
      await api
        .get("setting/options")
        .then((response) => {
         
          let options = {};
          let data = response.data.data;
          data.options.forEach((item) => {
            if (!options[item.type]) {
              options[item.type] = {};
            }
            options[item.type][item.id] = item;
          });
          delete data.options;
          data.options = options;
          set("setData", response.data.data);
        })
        .catch(function (error) {
          console.log("error_catch", error);
        });
      get;
    },
  },
});
